import './ChartGrid.css';
export var area = '_13lzg4k1-3-12-1';
export var plot = '_13lzg4k2-3-12-1';
export var plotLayout = '_13lzg4k0-3-12-1';